import Plus from '@mui/icons-material/AddOutlined';
import Minus from '@mui/icons-material/RemoveOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';

interface AccordionFAQProps {
  id: number;
  question: string;
  answer: string;
  expanded: number | false;
  openClose: (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

interface AccordionStyledProps {
  active: boolean;
}

export default function AccordionFAQ({
  id,
  question,
  answer,
  expanded,
  openClose,
}: AccordionFAQProps) {
  const [active, setActive] = useState(false);
  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!node.current) return;
    if (active) {
      node.current.style.height = node.current.scrollHeight + 'px';
    } else {
      node.current.style.height = 0 + 'px';
    }
  }, [active]);
  return (
    <AccordionStyled active={active} expanded={expanded === id} onChange={openClose(id)}>
      <AccordionSummary
        onClick={() => setActive(!active)}
        expandIcon={active ? <Minus /> : <Plus />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          color: '#12344A',
          fontWeight: '500',
          padding: '0.25rem 1rem',
          minHeight: '60px !important',
        }}
      >
        {id} - {question}
      </AccordionSummary>
      <AccordionDetailsStyled>
        <BoxStyled>
          <div dangerouslySetInnerHTML={{ __html: answer }}></div>
        </BoxStyled>
      </AccordionDetailsStyled>
    </AccordionStyled>
  );
}

export const AccordionDetailsStyled = styled(AccordionDetails)(() => ({
  color: '#888888',
  '&& a': {
    color: '#85C440',
  },
  '&& td': {
    color: '#12344A',
    fontWeight: '500',
  },
}));

export const AccordionStyled = styled(Accordion)<AccordionStyledProps>(({ active }) => ({
  width: '100%',
  borderRadius: '5px',
  margin: active ? '1rem auto !important' : '0.75rem auto !important',
  borderTop: 'none',
  '::before': {
    display: 'none',
  },
}));

export const BoxStyled = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      height: '5px',
      borderRadius: '0 15px 15px 0',
      backgrounColor: 'white',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#85C440',
      borderRadius: '10px',
    },
  },
}));
